import { useEffect as a } from "react";
const s = _ref => {
  let {
    isUncontrolledMode: o,
    uncontrolledOpen: n,
    controlledOpen: c,
    openCallback: l,
    closeCallback: e,
    isMounted: u
  } = _ref;
  a(() => {
    !o && c && (l == null || l());
  }, [c, o, l]), a(() => {
    !o || !u || (n ? l == null || l() : e == null || e());
  }, [e, u, o, l, n]);
};
export { s as useCallbacks };